/**
 * Copies the image represented by the given data URL to the clipboard.
 */
export function copyImageToClipboard(getImageDataUrl: () => Promise<string>, onSuccess: () => void, onFailure: (dataUrl: string | null) => void) {
    try {
        navigator.clipboard.write([
            // eslint-disable-next-line no-undef
            new ClipboardItem({
                // Handle the async conversion of dataURL to Blob inside the ClipboardItem
                // see https://bugs.webkit.org/show_bug.cgi?id=222262
                // eslint-disable-next-line no-async-promise-executor
                "image/png": new Promise(async (resolve) => {
                    // Everything async needs to be within this promise to allow for it to work on Safari
                    let dataUrl: string | null = null;
                    try {
                        dataUrl = await getImageDataUrl();
                        const response = await fetch(dataUrl);
                        resolve(await response.blob());
                        onSuccess();
                    } catch {
                        onFailure(dataUrl);
                    }
                }),
            }),
        ]);
    } catch {
        onFailure(null);
    }
}
